import { UITexts } from '../../types/ui';

export const uiTexts: UITexts = {
  language: {
    name: "Ukrainian",
    nativeName: "Українська",
    code: "uk",
    flag: "🇺🇦"
  },

  common: {
    loading: "Секундочку...",
    error: "Ой, щось пішло не так",
    retry: "Спробувати ще раз",
    back: "Назад",
    next: "Далі",
    previous: "Попередній",
    finish: "Готово",
    start: "Розпочинаємо!",
    restart: "Спочатку",
    continue: "Продовжуємо",
    cancel: "Скасувати",
    close: "Закрити",
    ok: "Зрозуміло",
    yes: "Так",
    no: "Ні",
    save: "Зберегти",
    share: "Поділитися",
    copy: "Скопіювати",
    copied: "Скопійовано!",
    minutes: "хвилин",
    seconds: "секунд",
    question: "питання",
    questions: "питань",
    answer: "відповідь",
    answers: "відповідей",
    correct: "Вірно",
    incorrect: "Невірно",
    score: "Результат",
    time: "Час",
    difficulty: {
      easy: "Легко",
      medium: "Середньо",
      hard: "Складно",
      // ISTQB Knowledge levels
      k1: "K1 Запам'ятати",
      k2: "K2 Зрозуміти",
      k3: "K3 Застосувати", 
      k4: "K4 Проаналізувати"
    }
  },

  demo: {
    title: "AI-тестер",
    subtitle: "Пробна версія",
    description: "Готові до зарплати AI-тестувальника? Перевірте за 15 хвилин",
    startButton: "Дізнатися свій рівень",
    badge: "БЕЗКОШТОВНА ПРОБА",
    features: {
      title: "Що вас чекає в повній версії",
      items: [
        "300+ експертних питань",
        "11 повних розділів програми",
        "40-хвилинна симуляція іспиту",
        "Детальні пояснення відповідей",
        "Аналітика результатів та оцінювання",
        "Множинні сесії практики",
        "Миттєвий та довічний доступ",
        "Мобільний формат",
        "Бонус: Ранній доступ до продвинутого курсу з AI-тестування"
      ],
      smartQuestions: {
        title: "Продумані питання",
        description: "Реальні сценарії з практики AI-тестування"
      },
      instantFeedback: {
        title: "Миттєвий зворотний зв'язок",
        description: "Персоналізовані пояснення від практика з 10+ річним досвідом"
      },
      previewPower: {
        title: "Симуляція справжньої сертифікації",
        description: "Відчуйте, яково це — готуватися до справжньої сертифікації"
      }
    },
    comparison: {
      demo: {
        title: "БЕЗКОШТОВНА ПРОБА",
        features: [
          "12 відібраних питань",
          "2 ключові теми",
          "15 хвилин часу",
          "Результат одразу"
        ]
      },
      full: {
        title: "ПОВНА ВЕРСІЯ",
        features: [
          "300+ експертних питань",
          "Усі 11 розділів програми",
          "40 хвилин як на справжньому іспиті",
          "Детальна аналітика",
          "Відстеження прогресу"
        ],
        button: "Отримати повний доступ"
      }
    },
    community: "Приєднуйтесь до AI спільноти професіоналів, які розкривають секрети тестування штучного інтелекту",
    trustIndicators: "Створено на основі офіційних матеріалів ISTQB",
    perfectFor: {
      title: "Ідеально підходить для",
      items: [
        "QA-інженерів, що переходять на AI-тестування",
        "Тестувальників ПЗ, що розширюють свої навички",
        "IT-фахівців, що прагнуть до сертифікації ISTQB",
        "Усіх, хто готується до співбесід з AI-тестування",
        "Команд, що підвищують кваліфікацію в галузі якості AI",
        "IT-професіоналів, що розвивають кар'єру"
      ]
    }
  },

  // Access Page
  access: {
    title: "Вхід до повної версії",
    subtitle: "Введіть код доступу",
    description: "Отримайте необмежений доступ до 300+ експертних питань з AI-тестування та повноцінної підготовки до іспиту.",
    form: {
      title: "Введіть код доступу",
      placeholder: "Ваш код доступу...",
      button: "Відкрити повну версію",
      submitting: "Перевіряємо..."
    },
    errors: {
      invalid: "Хм, код не підходить. Перевірте і спробуйте ще раз.",
      empty: "Введіть, будь ласка, код доступу.",
      generic: "Щось зламалося. Спробуйте ще раз."
    },
    success: {
      title: "Ласкаво просимо! 🎉",
      description: "Тепер у вас є необмежений доступ до повної версії ISTQB AI Tester!",
      validDays: "Ваш доступ діє постійно",
      continueButton: "До повної версії"
    },
    purchase: {
      title: "Немає коду доступу?",
      subtitle: "Отримайте доступ прямо зараз",
      description: "Почніть підготовку до сертифікації з 300+ питаннями, персоналізованими поясненнями та повним покриттям програми.",
      features: [
        "300+ експертних питань",
        "Усі 11 розділів програми",
        "Персоналізовані пояснення від практика з 10+ річним досвідом",
        "Аналітика результатів",
        "Працює на телефоні",
        "Довічний доступ + усі оновлення безкоштовно"
      ],
      button: "Почати підготовку до сертифікації",
      note: "Завантаження одразу після покупки"
    },
    security: {
      note: "Коди доступу надійно зашифровані та захищені",
      expiry: "Необмежений доступ"
    }
  },

  full: {
    title: "Навчання AI Tester",
    subtitle: "AI Tester Квіз",
    description: "Освойте всі 11 розділів програми ISTQB AI Testing",
    features: [
      "300+ експертних питань",
      "Усі 11 розділів",
      "40 хвилин як на справжньому іспиті"
    ],
    welcome: {
      keyFeatures: {
        title: "Головні фішки",
        expertQuestions: {
          title: "300+ питань",
          features: [
            "Вся програма повністю",
            "Як на справжньому іспиті",
            "Різні рівні складності"
          ]
        },
        adaptiveSystem: {
          title: "Розумна система",
          features: [
            "Підлаштовується під вас",
            "Вибирає відповідні питання",
            "Стежить за прогресом"
          ]
        },
        detailedAnalytics: {
          title: "Детальна аналітика",
          features: [
            "Аналіз ваших результатів",
            "Знаходить слабкі місця",
            "Підказує, що вивчати"
          ]
        }
      },
      whatMakesDifferent: {
        title: "Чому професіонали обирають нас",
        expertCreated: {
          title: "Зроблено експертами",
          description: "Питання створювали практики AI-тестування, які знають все про теорію і практику"
        },
        completeCoverage: {
          title: "Повне покриття",
          description: "Усі 11 розділів програми ISTQB AI Tester v1.0 розібрані по кісточкам"
        },
        realScenarios: {
          title: "Реальні ситуації",
          description: "Практичні кейси, з якими ви точно зіткнетеся в роботі AI-тестувальника"
        },
        trackProgress: {
          title: "Відстеження прогресу",
          description: "Детальна аналітика покаже ваші сильні та слабкі сторони"
        }
      },
      perfectFor: {
        title: "Ідеально підходить",
        items: [
          "QA-інженерам, які хочуть перейти в AI-тестування",
          "Тестувальникам, що розширюють свій арсенал навичок",
          "IT-спеціалістам, націленим на ISTQB-сертифікацію",
          "Усім, хто готується до співбесід з AI-тестування",
          "Командам, що прокачують експертизу в галузі AI",
          "Професіоналам, що будують кар'єру в IT"
        ]
      },
      startButton: "Почати шлях до сертифікації",
      trustIndicators: [
        "Перевірено тисячами кандидатів по всьому світу"
      ]
    }
  },

  quiz: {
    header: {
      title: "AI Tester Квіз",
      timeLeft: "Часу залишилося",
      progress: "Прогрес",
      streak: "Серія"
    },
    navigation: {
      previous: "Назад",
      next: "Далі",
      finish: "Закінчити",
      questionOverview: "Усі питання",
      swipeHint: "👈 Гортайте пальцем ліворуч-праворуч 👉"
    },
    status: {
      answered: "Відповів",
      notAnswered: "Пропущено",
      current: "Зараз тут"
    }
  },

  results: {
    title: "ПРОБА ЗАВЕРШЕНА",
    congratulations: "Чудово!",
    percentage: "% набрано",
    complete: "КВІЗ ПРОЙДЕНО",
    status: {
      passed: "Result",
      failed: "Result",
      retry: "ЩЕ РАЗ",
      pass: "Pass",
      study: "Not Pass"
    },
    performance: {
      genius: "Геній AI-тестування",
      expert: "Експерт AI-тестування",
      pro: "Профі AI-тестування",
      learner: "Вивчає AI-тестування",
      beginner: "Новачок в AI-тестуванні",
      // Full quiz performance levels
      master: "Майстер AI-тестування",
      professional: "Професіонал AI-тестування",
      candidate: "Кандидат в AI-тестувальники",
      // Perfect score level
      perfectMaster: "🎊 АБСОЛЮТНИЙ МАЙСТЕР 🎊"
    },
    statistics: {
      correct: "Правильно",
      total: "Всього Питань",
      bestStreak: "Найкраща серія",
      timeSpent: "Витрачено часу",
      questions: "Питань",
      status: "Статус"
    },
    actions: {
      showReview: "Подивитися розбір",
      hideReview: "Сховати розбір",
      tryAgain: "Пройти пробу знову",
      tryAgainNew: "Спробувати нові питання",
      shareResults: "Похвалитися результатом!",
      shareLinkedIn: "Поділитися в LinkedIn"
    },
    sharing: {
      title: "Похваліться результатом! 🎉",
      description: "Покажіть колегам свої знання AI-тестування!",
      hashtags: ["ISTQB", "AITesting", "Certification", "TechSkills", "SoftwareQuality"],
      messages: {
        success: "🎉 Готово! LinkedIn відкрито, результат скопійовано!",
        clipboard: "🎉 Результат скопійовано в буфер!",
        manual: "Скопіюйте цей текст для публікації в LinkedIn:"
      },
      // Perfect score sharing
      perfectScore: {
        title: "🎊 ІДЕАЛЬНИЙ РЕЗУЛЬТАТ! 🎊",
        description: "В пості є секретний хештег для 30% знижки!",
        hashtag: "#ainastasiaquizwinner",
        discountOffer: "30% знижка на повний курс!",
        championText: "Тепер ви офіційний чемпіон AI-тестування!",
        hiddenModeUnlocked: "🎉 ВАУ! ВИ ВІДКРИЛИ ПРИХОВАНИЙ РЕЖИМ! 🎉",
        hiddenModeTitle: "ПРИХОВАНИЙ РЕЖИМ АКТИВОВАНО!",
        russianCongratulations: "🎉 ВАУ! ВИ ВІДКРИЛИ ПРИХОВАНИЙ РЕЖИМ! 🎉",
        perfectScoreMessage: "Ви відповіли правильно на ВСІ 40 питань і розблокували секретний режим!",
        championOfferTitle: "🎁 СПЕЦІАЛЬНА ПРОПОЗИЦІЯ ДЛЯ ЧЕМПІОНА:",
        specialOffer: "КРУТА ПРОПОЗИЦІЯ: Поділіться цим постом і напишіть мені в соцмережі з посиланням на ваш пост — отримайте 30% знижку на повний курс!",
        contactInstructions: "Опублікуйте пост в LinkedIn з хештегом #ainastasiaquizwinner і напишіть мені в соцмережі з посиланням на пост — отримайте 30% знижку на основний курс!",
        linkedinButtonHint: "💡 В кнопці 'Поділитися в LinkedIn' вже є готовий текст з секретним хештегом"
      }
    },
    upgrade: {
      title: "Готові до повної версії?",
      description: "Дізнайтеся, чи готові ви до підвищення зарплати на 30%",
      features: [
        "300+ експертних питань",
        "Усі 11 розділів",
        "тренування з унікальними питаннями"
      ],
      button: "Отримати повний доступ"
    },
    course: {
      title: "Курс теорії AI-тестування",
      subtitle: "📚 ПРОКАЧКА НАВИЧОК",
      description: "Готові глибше занурюватися? Приєднуйтесь до нашого комплексного теоретичного курсу для підготовки до сертифікації ISTQB AI Tester.",
      features: [],
      button: "Отримати знижку ранньої пташки",
      // Full quiz course promotion
      fullCourse: {
        nextLevel: "🎓 НА ВАС ЧЕКАЄ НАСТУПНИЙ РІВЕНЬ 🎓",
        masterTitle: "Курс теорії AI-тестування",
        masterDescription: "Піднесіть свої знання AI-тестування до професійного рівня з нашим комплексним теоретичним курсом. Дізнайтеся не тільки ЩО тестувати, а й ЯК тестувати AI-системи як справжній професіонал!",
        bonusTitle: "🎁 БОНУС ДЛЯ УЧАСНИКІВ КВІЗУ 🎁",
        bonusDescription: "15% ЗНИЖКА + ексклюзивні матеріали",
        claimButton: "🔥 ЗАБРАТИ БОНУС ЗАРАЗ 🔥"
      }
    },
    feedback: {
      title: "Є ідеї, як покращити продукт?",
      button: "Залишити відгук"
    },
    social: {
      title: "Підписуйтесь на AI.Nastasia! 🚀",
      description: "Приєднуйтесь до тусовки",
      platforms: {
        instagram: "Instagram",
        tiktok: "TikTok",
        linkedin: "LinkedIn",
        telegram: "Telegram"
      }
    }
  },

  review: {
    title: "Розбір відповідей",
    yourAnswer: "Ваша відповідь:",
    correctAnswer: "Правильна відповідь:",
    explanation: "Пояснення:",
    notAnswered: "Пропущено"
  },

  languageSelector: {
    title: "Оберіть мову",
    current: "Зараз обрано",
    available: "Доступні мови",
    select: "Обрати"
  },

  mobile: {
    pullToRefresh: "↓ Потягніть вниз щоб оновити ↓",
    swipeInstructions: "👈 Гортайте пальцем ліворуч-праворуч 👉",
    tapToSelect: "Торкніться щоб обрати відповідь",
    doubleTapToConfirm: "Подвійний тап для підтвердження"
  },

  a11y: {
    languageSelector: "Вибір мови",
    questionProgress: "Питання {current} з {total}",
    optionSelected: "Обрано варіант {option}",
    timerWarning: "Час майже закінчився",
    resultsSummary: "Квіз завершено з результатом {score}%"
  }
};